enum AppMediumState {
    Enabled = "ENABLED",
    Disabled = "DISABLED"
}
export default AppMediumState